import React from "react";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";
import { cleanDate } from "../../../../util/app";
import FabButton from "../../../../partials/Buttons/FabButton";
/**
 *
 * @param {any} item object containing health glucose monitoring
 */
function GlucoseMonitoringDetail({ item, onAddRoute }) {
    return (
        <>
            <div className="row">
                <div className="col-4 bg-primary pl-5">
                    <h5>Detail</h5>
                </div>
                <div className="col-12">
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                    <strong>Start Date</strong>
                                </td>
                                <td style={{ width: "60%" }}>{cleanDate(item.start)}</td>
                            </tr>
                            <tr>
                                <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                    <strong>End Date</strong>
                                </td>
                                <td style={{ width: "60%" }}>{cleanDate(item.end)}</td>
                            </tr>
                            <tr>
                                <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                    <strong>Status</strong>
                                </td>
                                <td style={{ width: "60%" }}>{item.active ? <span className="badge badge-success">Active</span> : <span className="badge badge-danger">Passed</span>}</td>
                            </tr>
                            <tr>
                                <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                    <strong>Staff</strong>
                                </td>
                                <td style={{ width: "60%" }}>
                                    <StaffProfileCard item={item.author} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <div className="col-4 bg-primary pl-5">
                    <h5>Routines</h5>
                </div>
                <div className="col-12">
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Result</strong>
                                </td>
                                <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                                    <strong>Comment</strong>
                                </td>
                                <td style={{ width: "20%", backgroundColor: "aliceblue" }}>
                                    <strong>Date</strong>
                                </td>
                                <td style={{ width: "20%", backgroundColor: "aliceblue" }}>
                                    <strong>Staff</strong>
                                </td>
                            </tr>
                            {item.routines.map((r, i) => (
                                <tr key={i}>
                                    <td>
                                        <p>{r.result}</p>
                                    </td>
                                    <td>
                                        <p>{r.comment}</p>
                                    </td>
                                    <td>{cleanDate(r.date)}</td>
                                    <td>
                                        <StaffProfileCard item={r.author} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            {item.active && <FabButton title="Add Routine" onClick={() => onAddRoute(item)} />}
        </>
    );
}

export default GlucoseMonitoringDetail;
